import jQuery from 'jquery';
import angular from 'angular';

function Directive() {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    template: '<p class="read-more-text"></p>',
    scope: {
      text: '=',
      moreText: '@',
      lessText: '@',
      words: '@',
      ellipsis: '@',
      char: '@',
      limit: '@',
      content: '@'
    },
    link(scope, elem, attr) {
      const moreText = '<a href="#" class="read-more">Read More...</a>';
      const lessText = '<a href="#" class="read-less">Read Less...</a>';

      const ellipsis = angular.isUndefined(scope.ellipsis) ? '' : scope.ellipsis;
      const limit = angular.isUndefined(scope.limit) ? 150 : parseInt(scope.limit, 10);

      scope.$watch('text', function(text) {
        if (!text) return;
        readmore(text);
      });

      function readmore(text) {
        if (!text) return;

        const orig = text;
        const regex = /\s+/gi;
        const charCount = text.length;
        const wordCount = text.trim().replace(regex, ' ').split(' ').length;
        let countBy = 'char';
        let count = charCount;
        let foundWords = [];
        let markup = text;
        let more = '';

        if (!angular.isUndefined(attr.words)) {
          countBy = 'words';
          count = wordCount;
        }

        if (countBy === 'words') { // Count words
          foundWords = text.split(/\s+/);

          if (foundWords.length > limit) {
            text = foundWords.slice(0, limit).join(' ') + ellipsis;
            more = foundWords.slice(limit, count).join(' ');
            markup = text + moreText + '<span class="more-text">' + more + lessText + '</span>'; //eslint-disable-line
          }
        } else if (count > limit) {
          text = orig.slice(0, limit) + ellipsis;
          more = orig.slice(limit, count);
          markup = text + moreText + '<span class="more-text">' + more + lessText + '</span>'; //eslint-disable-line
        }

        elem.append(markup);

        elem.find('.read-more').on('click', function() {
          jQuery(this).hide();

          elem.find('.more-text').addClass('show').slideDown();
        });

        elem.find('.read-less').on('click', function() {
          elem.find('.read-more').show();
          elem.find('.more-text').hide().removeClass('show');
        });
      }
    }
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/readmore/index.js